var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Base',{attrs:{"onSubmit":(params) => _vm.reportsService.createCase(params),"trigerPrevent":_vm.trigerPrevent,"isQr":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }